import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import FieldError           from '../Fragments/FieldError';

let Quote = require('../Managers/Quote.js');
let Validation = require('../Managers/Validation.js');

class PostcodeInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isHelpVisible: false,
            activeValue: props.defaultValue ? props.defaultValue : '',
        };
    }

    componentWillMount() {
        if (this.props.defaultValue) {
            this.setState({isValid: true});
            this.props.isValid(true);
        }
        if (window.uorn(this.props.dataValidation)) {
            this.setState({isValid: true});
            this.props.isValid(true);
        }
    }

    handleValidation(value) {
        let v = value.toUpperCase();
        v = v.replace(/\s+/g, '');
        let inner = v.substring(v.length - 3);
        let outer = v.split(inner).join('');
        v = outer + ' ' + inner;

        if (this.props.defaultValue) {
            this.setState({isValid: true});
            this.props.isValid(true);
        }

        if (this.props.dataValidation) {
            let validation = Validation.validate(this.props.dataValidation, v, 'not_null')[0];
            this.setState(validation);
            if (validation.isValid) {
                this.props.isValid(true);
                Quote.set(this.props.storageKey, v, this.props.source);
                Quote.setAnswer(this.props.storageKey, v);
            } else {
                this.props.isValid(false);
            }
        } else {
            // todo: find out if we want to show a 'tick' against non-required fields on blur if they have nothing in them
            Quote.set(this.props.storageKey, v, this.props.source);
            Quote.setAnswer(this.props.storageKey, v);
            this.setState({isValid: true});
            this.props.isValid(true);
        }

        if (this.props.callbackFunction) {
            this.props.callbackFunction(v);
        }

        this.setState({ activeValue: v });
    }

    getCurrentValue() {
        return this.state.activeValue;
    }

    render() {
        return (
            <div className="question-input">
                <input
                    name={this.props.fieldName}
                    id={this.props.fieldName}
                    type="text"
                    maxLength={this.props.maxLength}
                    onBlur={(event) => { this.handleValidation(event.target.value); }}
                    defaultValue={this.props.defaultValue}
                />

                {this.state.hasError === true ?
                    <FieldError errors={this.state.errors} />
                :null}
            </div>
        );
    }
}

PostcodeInput.propTypes = {
    fieldName:          PropTypes.string.isRequired,
    storageKey:         PropTypes.string,
    question:           PropTypes.string.isRequired,
    maxLength:          PropTypes.number.isRequired,
    callbackFunction:   PropTypes.func,
    dataValidation:     PropTypes.string,
    defaultValue:       PropTypes.string,
    source:             PropTypes.string,
    isValid:            PropTypes.func,
};

export default PostcodeInput;


// WEBPACK FOOTER //
// ./src/components/Fields/PostcodeInput.js